"use strict";
/*
 * Created on 26. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("./AdtFlag");
/**
 * Base class for progress monitor kinds - identification of context, where monitored action runs.
 *
 * @author Stepan Mik
 */


var ProgressMonitorKind =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(ProgressMonitorKind, _AdtFlag_1$AdtFlag);

  function ProgressMonitorKind() {
    _classCallCheck(this, ProgressMonitorKind);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProgressMonitorKind).apply(this, arguments));
  }

  _createClass(ProgressMonitorKind, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(ProgressMonitorKind, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(ProgressMonitorKind, data);
    }
  }, {
    key: "getConstructor",
    value: function getConstructor(tag) {
      return AdtFlag_1.AdtFlag.getConstructorBase(ProgressMonitorKind, tag);
    }
  }]);

  return ProgressMonitorKind;
}(AdtFlag_1.AdtFlag);

exports.ProgressMonitorKind = ProgressMonitorKind;
ProgressMonitorKind.TAG = '__ProgressMonitorKind__';